import { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form'

import { ServerErrorResponse } from '@orbit/errors'

/**
 * Handles submission error for react hook form
 */
export const handleFormSubmissionErrorRHF = <T extends FieldValues>(error: unknown, formApi: UseFormReturn<T>) => {
  const submitError = error as ServerErrorResponse

  if (submitError.meta) {
    Object.entries(submitError.meta).forEach(([key, value]) => {
      const regexp = /^(.*)]$/i
      formApi.setError(key.replace(regexp, '$1].value') as FieldPath<T>, {
        message: value.pop()
      })
    })

    setTimeout(() => {
      const element = document.querySelector(`[data-field-with-error]`)
      element?.scrollIntoView({ block: 'center', behavior: 'smooth' })
    }, 0)
  }
}
